import { React, useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import moment from 'moment';

import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';

const FailedSubscriptMembershipInfoView = forwardRef((props, ref) => {
  const {
    data,
    index,
    size,
    retryClick,
    deleteClick,
  } = props;

  const [isClicked, setIsClicked] = useState(false);
  const [buttonImage, setButtonImage] = useState(MemberShipHistoryInfoButtonImagePath);
  const [fontColor, setFontColor] = useState('#595959');
  const [border, setBorder] = useState('1px solid #FFFFFF');
  const [hoverBorder, setHoverBorder] = useState('1px solid #FFFFFF');
  const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();
  const OptionRetryRef = useRef();
  const OptionDeleteRef = useRef();

  useImperativeHandle(ref, () => ({
    setIsClicked: () => {
      setIsClicked(false);
    },
    getButtonRef: () => {
      return OptionButtonRef.current;
    },
    getBoxRef: () => {
      return OptionBoxRef.current;
    }
  }))

  useEffect(() => {
    if (data.isExpectedMemberShip) return;

    if (isClicked) {
      OptionBoxRef.current.style.height = `64px`;
      OptionBoxRef.current.style.border = `1px solid #FF8B48`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #FF8B48`;
    }
  }, [isClicked, data])

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  useEffect(() => {
    setFontColor('#D92828');
    setBorder('1px solid #FFFFFF');
    setHoverBorder('1px solid #FF8B48');
    setBackgroundColor('#FFFFFF');
    setButtonImage(MemberShipHistoryInfoButtonImagePath);
  }, [data])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionRetryRef.current !== e.target
      && OptionDeleteRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  // 결제 금액 정리 //
  function decideTotalPriceView() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + data.terminationReason;
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + data.terminationReason;
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + data.terminationReason;
    } 
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.paymentOptionName === data.selectedPaymentOptions[0].paymentOptionName);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + data.terminationReason;
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + data.terminationReason;
    }
  }

    // 남은일수에 맞춰 텍스트 정리 //
    function remainDaysView() {
      if (data.isRefund) return '환불';
      else if (data.isExpectedMemberShip) return '결제예정';
      else if (data.totalMax === data.courseTakeCount
        && (data.lastReserveDate !== undefined && (moment().startOf('day').isAfter(data.lastReserveDate)))) return '만료';
      else if (moment().isBefore(data.startDate)) return '예정';
      else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') > 0) {
        return moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') + '일';
      }
      else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') === 0) {
        return 'D-Day'
      }
  
      return '만료';
    }


  // 수강 횟수 표시 //
  function decideUseTotalMax() {
    if (data.totalMax === -1) return data.courseTakeCount + '/∞';
    else return data.courseTakeCount + '/' + data.totalMax;
  }
  
  // 마우스 호버링
  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  // 마우스 호버링
  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }


  // 몸체 눌렀을때 켜지기 //
  function onClickBody(e) {
    // if (e.target === OptionButtonRef.current || OptionBoxRef.current.contains(e.target)) return;

    // modifyClick(index);
  }

  return (
    <TopLevelWrapper>
      <MemberShipComponent
        zIndex={80 + size - index}
        border={border}
        hoverBorder={hoverBorder}
        backgroundColor={backgroundColor}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        onClick={onClickBody}>
        <Table>
          <Body>
            <Tr style={{ width: '301px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '301px', gap: '4px' }}>
                  {
                    data.isSubscriptionMembership &&
                    <SubscriptionBox status={data.subscribeStatus && !data.subscribeDeleted}>
                      <SubscriptionText>{(data.subscribeStatus && !data.subscribeDeleted) ? `구독중` : `구독 종료`}</SubscriptionText>
                    </SubscriptionBox>
                  }
                  <Text color={fontColor}>{data.memberShipName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '152px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '127px' }}>
                  <Text color={fontColor}>
                    {data.startDate.slice(2, 10).replaceAll('-', '.')} - {data.endDate.slice(2, 10).replaceAll('-', '.')}
                  </Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '164px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '160px' }}>
                  <Text color={fontColor}>{decideTotalPriceView()}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '190px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '180px' }}>
                  <Text color={fontColor}>{data.notReceivedPrice}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '70px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '66px' }}>
                <Text color={fontColor}>{remainDaysView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '83px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '53px' }}>
                <Text color={fontColor}>{decideUseTotalMax()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
            <Tr>
              <Td>
                <OptionButton ref={OptionButtonRef} src={buttonImage} onClick={() => setIsClicked(!isClicked)} />
                <OptionWrapper ref={OptionBoxRef}>
                  <Option ref={OptionRetryRef} onMouseDown={() => retryClick(index)}>재결제</Option>
                  <Option ref={OptionDeleteRef} onMouseDown={() => deleteClick(index)}>삭제</Option>
                </OptionWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </MemberShipComponent>
    </TopLevelWrapper>
  )
});

export default FailedSubscriptMembershipInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;
`;

const MemberShipComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 1018px;
  height: 50px;

  box-shadow: 0px 10px 50px rgba(240, 232, 227, 0.5);

  z-index: ${props => props.zIndex};

  border: ${props => props.border};
  border-radius: 30px;
  background-color: ${props => props.backgroundColor};
    
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    border: ${props => props.hoverBorder};
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
    
  // margin-left: 28px;
  margin-left: 15px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const SubscriptionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // padding: 0px 5px;
  margin-top: 2px;

  min-width: ${props => props.status ? `40px` : `54px`};
  min-height: 18px;

  border-radius: 5px;
  // background-color: #FF8B48;
  background-color: ${props => props.status ? `#FF8B48` : `#6DD49E`};
`;

const SubscriptionText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #FFFFFF;

  margin: -2px 0 0 0;
  padding: 0 0 0 0;

  :hover {
    cursor: default;
  }
`;

const OptionButton = styled.img`
  opacity: 0;
    
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
    
  z-index: 10;

  margin-top: 40px;
  margin-left: -20px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 58px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF8B48;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #FF8B48;
  }
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  opacity: 0;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;